<template>
  <v-container class="pa-12 fill-height align-start" fluid>
    <v-row>
      <v-col>
        <div class="headline">{{ $t("configureTranslationsLabel") }}</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" class="d-flex align-center py-4">
        <v-card width="660" flat>
          <v-card-subtitle>{{ $t("exportCsvLabel") }}</v-card-subtitle>
          <v-card-text>
            <div class="d-flex align-center">
              <v-select dense outlined hide-details :label="$t('targetLabel')" :items="languagesFiltered" item-text="name"
                v-model="targetLanguage" class="mr-3" return-object></v-select>
              <v-btn small depressed height="40px" color="primary" @click="exportTranslation"
                :loading="exportinTranslation" :disabled="!targetLanguage || exportinTranslation">
                {{ $t("exportLabel") }}</v-btn>
            </div>
            <template v-if="exportFile.base64String">
              <v-btn depressed small class="mt-4 white--text" color="tertiary" :download="exportFile.fileName"
                :href="exportFile.base64String">{{ $t("downloadCsvLabel") }}</v-btn>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" class="d-flex align-center py-4">
        <v-card width="660" flat>
          <v-card-subtitle>{{ $t("importCsvLabel") }}</v-card-subtitle>
          <v-card-text>
            <div class="d-flex align-center">
              <v-file-input dense outlined hide-details prepend-icon="" prepend-inner-icon="mdi-file-excel"
                :label="$t('fileInputLabel')" @change="attachedTranslationEventHandler" class="mr-3"></v-file-input>
              <v-btn small depressed height="40px" color="primary" @click="importTranslation"
                :disabled="!importFile.base64String || importingTranslation" :loading="importingTranslation">
                {{ $t("importLabel") }}</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {
    mapGetters
  } from "vuex";

  export default {
    name: "translations",
    data: () => ({
      languagesFiltered: null,
      targetLanguage: null,
      base64File: "",
      importFile: {
        base64String: "",
        fileName: "",
        fileExtension: "",
      },
      exportFile: {
        base64String: "",
        fileName: "",
      },
      snackbar: {
        show: true,
        message: "",
      },
      exportinTranslation: false,
      importingTranslation: false,
    }),
    computed: {
      ...mapGetters(["languages", "getCurrentUser"]),
    },
    mounted() {
      this.languagesFiltered = this.languages.filter(lang => lang.id != this.getCurrentUser.preferedLanguage.id)
    },
    methods: {
      exportTranslation() {
        this.exportinTranslation = true;
        this.axios
          .get("api/translate/generateTranslatableCsv", {
            params: {
              sourceLanguage: this.getCurrentUser.preferedLanguage.id,
              targetLanguage: this.targetLanguage.id,
            },
          })

          .then((response) => {
            let csvContent = decodeURIComponent(escape(window.atob(response.data)));
            var fileURL = window.URL.createObjectURL(
              new Blob(
                [
                  "\uFEFF"+csvContent
                ], {
                type: "data:application/excel;base64",
              })
            );
            let sourceLanguageString = this.getCurrentUser.preferedLanguage.isO639
            let targetLanguageString = this.targetLanguage.isO639
            this.exportFile.base64String = fileURL;
            this.exportFile.fileName = "translations_"+sourceLanguageString+"_"+targetLanguageString+".csv";
            this.exportinTranslation = false;
          })
          .catch((error) => {
            this.snackbar.message = error.message;
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.exportinTranslation = false;
          });
      },
      attachedTranslationEventHandler(event) {
        if (typeof event !== "undefined") {
          const file = event;
          this.importFile.fileName = file.name.split(".")[0];
          this.importFile.fileExtension = file.name.split(".")[1];
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            this.importFile.base64String = reader.result.replace(
              /^data:.+;base64,/,
              ""
            );
          };
        } else {
          this.importFile.base64String = "";
          this.importFile.fileName = "";
          this.importFile.fileExtension = "";
        }
      },
      importTranslation() {
        this.importingTranslation = true;
        var base64String = this.importFile.base64String.replace("77u/","");

        const data = {
          baseSixtyFourString: base64String,
        };
        this.axios
          .post("api/translate/SubmitTranslatableCSV", data)
          .then((response) => {
            this.snackbar.message = this.$t("translationImportedLabel");
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.importingTranslation = false;
          })
          .catch((error) => {
            this.snackbar.message = error.message
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.importingTranslation = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>